import { InjectionKey } from 'vue';
import { useActiveDirectoryProvider } from '@/components/common/dialogs/settingsActiveDirectoryDialog/activeDirectory.helpers';
import { useManageSecurityGroupsHelpers } from '@/components/common/dialogs/settingsActiveDirectoryDialog/manageSecurityGroupsDialog/manageSecurityGroupsDialog.helpers';

export const IKActiveDirectory = Symbol('IKActiveDirectory') as InjectionKey<ReturnType<typeof useActiveDirectoryProvider>>;

export const IKActiveDirectoryManageGroups = Symbol('IKActiveDirectoryManageGroups') as InjectionKey<ReturnType<typeof useManageSecurityGroupsHelpers>>;
